import React, { cloneElement, Children } from 'react';
import { get } from 'lodash';

import magnifyingGlassIllustration from 'images/illustrations/magnifyingGlass.png';
import briefcaseIllustration from 'images/illustrations/briefcase.png';
import certificateIllustration from 'images/illustrations/certificate.png';
import clipboardIllustration from 'images/illustrations/clipboard.png';
import handshakeIllustration from 'images/illustrations/handshake.png';
import searchIllustration from 'images/illustrations/search.png';

import { SidebarConsumer } from 'components/structure/SidebarContext';
import { ButtonSet } from 'components/misc/ButtonSet';

import * as styled from './styles';

const ILLUSTRATIONS = {
  magnifyingGlass: magnifyingGlassIllustration,
  briefcase: briefcaseIllustration,
  certificate: certificateIllustration,
  clipboard: clipboardIllustration,
  handshake: handshakeIllustration,
  search: searchIllustration,
};

type EmptyStateProps = {
  title?: React.ReactNode;
  children?: React.ReactNode | null;
  illustration?: keyof typeof ILLUSTRATIONS;
  actions?: React.ReactNode[];
  className?: string;
  small?: boolean;
};

export const EmptyState = function EmptyState(props: EmptyStateProps) {
  const {
    title,
    children,
    illustration = 'magnifyingGlass',
    actions = [],
    className,
    small = false,
  } = props;

  return (
    <SidebarConsumer>
      {({ expanded: sidebarExpanded }) => (
        <styled.Container
          className={className}
          sidebarExpanded={sidebarExpanded}
        >
          <styled.Content>
            <styled.Header>
              <styled.IllustrationContainer small={small}>
                <styled.Illustration
                  src={get(
                    ILLUSTRATIONS,
                    illustration,
                    magnifyingGlassIllustration
                  )}
                />
              </styled.IllustrationContainer>
              <styled.Title small={small}>{title}</styled.Title>
            </styled.Header>

            <styled.Body>{children}</styled.Body>

            <styled.Footer>
              <ButtonSet align="center">
                {Children.map(actions, (action) =>
                  React.isValidElement(action)
                    ? cloneElement(action, { key: 'action' })
                    : action
                )}
              </ButtonSet>
            </styled.Footer>
          </styled.Content>
        </styled.Container>
      )}
    </SidebarConsumer>
  );
};
